import * as React from 'react'

import { Box, type Colors, InfoDot, Text } from '@factorialco/deprecated-design-system'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface Props {
  color: Colors
  text: string
  value: number
}

const InfoBox = ({ color, text, value }: Props) => (
  <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween" width="full">
    <Box flexDirection="row" gap="s8" alignItems="center">
      <InfoDot size="medium" color={color} />
      <Text size="100" weight="bold" color="grey800">
        {text.toUpperCase()}
      </Text>
    </Box>
    <MinutesToText color="grey1000" value={value} size="300" weight="medium" />
  </Box>
)

export default InfoBox
